import React, { useContext } from 'react';
import deTranslation from '../../../translations/de.json';
import nlTranslation from '../../../translations/nl.json';
// State
import LanguageProvider from '../../components/state';

function Translate(props: any) {
  const language = useContext(LanguageProvider);

  const sentence = [props.children ? props.children : props];

  const searchTerm = (sentence: Array<string>) => {
    // TODO: Alter functionality when another locale is added.
    // Switch between locales, create the corresponding .json file for the translation added.

    let filtered = {};
    if (language === 'de') {
      filtered = sentence.reduce(
        // @ts-ignore
        (obj, key) => ({ ...obj, [key]: deTranslation[key] }),
        {},
      );
    } else if (language === 'nl') {
      filtered = sentence.reduce(
        // @ts-ignore
        (obj, key) => ({ ...obj, [key]: nlTranslation[key] }),
        {},
      );
    } else {
      return sentence;
    }

    if (Object.values(filtered)[0]) {
      return Object.values(filtered)[0];
    } else return sentence;
  };

  return <> {sentence && searchTerm(sentence)}</>;
}

export default Translate;
